<template>
  <div class="text-center">
    <b-icon icon="shield-lock" class="h1" />
    <h4>شما به این بخش دسترسی ندارید.</h4>
  </div>
</template>

<script>
export default {
  name: "AccessDenied"
}
</script>

<style scoped>

</style>